import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=655ccc2a"
import script from "./ServiceDetails.vue?vue&type=script&lang=ts"
export * from "./ServiceDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports